﻿import { useParams, useNavigate } from "react-router-dom";

import CustomModalForm from "@/components/desktop/form/modal/CustomModalForm/CustomModalForm";
import CustomInputText from "@/components/desktop/form/input/input-text/CustomInputText";
import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect";
import CustomFetching from "@/components/desktop/fetching/CustomFetching";

import { base_object } from "../phenological.constants.js";
import { usePhenologicalStateForm } from "@/hooks/maintainers/OA/PhenologicalState/usePhenologicalStateForm.jsx";

const PhenologicalStateForm = ({ filters }) => {
	const navigate = useNavigate();
	const { option, element_id } = useParams();

	const onClose = () => {
		setFormState({ ...base_object });
		setFormErrors({});
		navigate("/configuracion/estado_fenologico_oa");
	};

	const {
		isOpen,
		modalTitle,
		isLoadingLookups,
		isLoadingSave,
		isLoadingElement,
		isFetchingElement,
		estateParentOptions,
		filteredEstateOptions,
		formState,
		setFormState,
		formErrors,
		setFormErrors,
		handleEstateParentsChange,
		handleSubmit,
	} = usePhenologicalStateForm({
		option,
		filters,
		elementId: element_id,
		baseObject: base_object,
		onClose,
	});

	if (!isOpen) return null;

	const hasSelectedParents = Array.isArray(formState.estate_parent_id) && formState.estate_parent_id.length > 0;

	const isLoading = isLoadingLookups || isLoadingSave || isLoadingElement || isFetchingElement;

	return (
		<CustomModalForm open={isOpen} onClose={onClose} title={modalTitle} size="sm" asForm onSubmit={handleSubmit} isLoading={isLoading}>
			{isLoading ? (
				<CustomFetching center size="lg" />
			) : (
				<>
					<CustomInputText
						label="Nombre"
						name="name"
						value={formState.name}
						onChange={(value) => {
							setFormState((prev) => ({ ...prev, name: value }));
							setFormErrors((prev) => ({ ...prev, name: undefined }));
						}}
						placeholder="Ingrese el nombre"
						required
						col={12}
						error={formErrors.name}
					/>

					<CustomInputSelect
						label="Campos"
						name="estate_parent_id"
						isMulti
						options={estateParentOptions}
						value={formState.estate_parent_id || []}
						onChange={(value) => {
							handleEstateParentsChange(value);
						}}
						placeholder="Seleccionar Campos"
						required
						col={12}
						error={formErrors.estate_parent_id}
					/>

					<CustomInputSelect
						label="Bodegas"
						name="estate_id"
						isMulti
						options={filteredEstateOptions}
						value={formState.estate_id || []}
						onChange={(value) => {
							setFormState((prev) => ({ ...prev, estate_id: value || [] }));
							setFormErrors((prev) => ({ ...prev, estate_id: undefined }));
						}}
						placeholder={hasSelectedParents ? "Seleccionar Bodegas" : "Seleccione primero Campo(s)"}
						required
						col={12}
						error={formErrors.estate_id}
					/>
				</>
			)}
		</CustomModalForm>
	);
};

export default PhenologicalStateForm;
